import InlineSvg from "react-inlinesvg";
// services
import { useMedia } from "@local/theme";
// types
import type { RefObject } from "react";
import type { Props as SVGProps } from "react-inlinesvg";

const DEFAULT_STYLE = {} as const satisfies SVGProps["style"];

const SIZES = {
	small: 24,
	medium: 30,
	large: 40,
} as const satisfies Record<string, number>;

type Props = Readonly<SVGProps & {
	ref?: RefObject<SVGElement>;
	size?: keyof (typeof SIZES) | number; // TODO: remove "number" fallback
}>;

const Svg = ({ ref, src, size = undefined, color = undefined, style = DEFAULT_STYLE, ...other }: Props) => {
	const { getMediaPath } = useMedia();

	const _src = getMediaPath(src);
	if (_src === undefined) {
		return null;
	}

	const _style = (color === undefined) ? style : {...style, color: color};

	if (size) {
		const _size = (typeof size === "number") ? size : SIZES[size];

		return (
			<InlineSvg
				innerRef={ref}
				src={_src}
				width={_size}
				height={_size}
				style={_style}
				{...other}
			/>
		);
	}

	return (
		<InlineSvg innerRef={ref} src={_src} style={_style} {...other} />
	);
};

export default Svg;
